import { useEffect, useRef, useState } from "react";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";

import { concatClassnames } from "shared/utils/concatClassnames";
import SelectedSamples from "../selected-samples";

interface Props {
  className?: string;

  selectedSamples: CategoryStandardProduct[];
  setSelectedSamples: (sample: CategoryStandardProduct[]) => void;
}
const SamplesConfiguratorHeader = ({
  className,
  selectedSamples,
  setSelectedSamples,
}: Props) => {
  return (
    <header
      className={concatClassnames(
        "gg-flex gg-justify-between gg-items-start",
        className
      )}
    >
      <Heading headingLevel="h2" className="gg-text-1.5xl lg:gg-text-2xl">
        Kies jouw kleurstalen
      </Heading>

      <SelectedSamples
        selectedSamples={selectedSamples}
        setSelectedSamples={setSelectedSamples}
        className="gg-hidden sm:gg-flex"
      />
    </header>
  );
};
export default SamplesConfiguratorHeader;
